<template>
  <v-data-table
    mobile-breakpoint="0"
    :items-per-page="10"
    item-key="generatedId"
    :headers="headers"
    :options.sync="tableOptions"
    :items="classesData"
    :server-items-length="totalItems"
    loading-text="Đang Tải"
    sort-by="name"
    :footer-props="footerTable"
    :loading="loading"
  >
    <template v-slot:[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} trên tổng
      {{ items.itemsLength }}
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <router-link style="text-decoration: none" :to="'/class/' + item.id" v-if="$auth.policies['view-class']">
        {{ item.title }}
      </router-link>
      <div v-else>
        {{ item.title }}
      </div>
    </template>
    <template v-slot:[`item.headTeachers`]="{ item }">
      <div class="d-flex flex-row">
        <div style="width:220px" class="mr-8">
          <div v-if="item.headTeachers && item.headTeachers.length">
            <div v-for="teacher in item.headTeachers" :key="teacher.id">
              <CardTeacherName link :teacher="teacher" />
            </div>
          </div>
          <div v-else>
            <span style="color:red">Chưa có giáo viên chủ nhiệm</span>
          </div>
        </div>
        <div style="width:80px" v-if="item.headTeachers && item.headTeachers.length" class="mr-8">
          <div
            v-for="(teacher, index) in item.headTeachers"
            :key="teacher.id"
            class="mt-2"
            :class="{
              'mt-6': index >= 1 && !$vuetify.breakpoint.smAndDown,
              'mt-4': index >= 1 && $vuetify.breakpoint.smAndDown
            }"
          >
            <div class="grey--text" v-if="!$vuetify.breakpoint.smAndDown">Ngày sinh</div>
            <div v-if="teacher && teacher.dob">{{ teacher.dob | ddmmyyyy }}</div>
            <div v-else-if="teacher.metadata && teacher.metadata.dob">
              {{ teacher.metadata.dob | ddmmyyyy }}
            </div>
          </div>
        </div>
        <div v-if="item.headTeachers && item.headTeachers.length">
          <div
            v-for="(teacher, index) in item.headTeachers"
            :key="teacher.id"
            class="mt-2"
            :class="{
              'mt-6': index >= 1 && !$vuetify.breakpoint.smAndDown,
              'mt-4': index >= 1 && $vuetify.breakpoint.smAndDown
            }"
          >
            <div class="grey--text" v-if="!$vuetify.breakpoint.smAndDown">Giới tính</div>
            <div>{{ teacher | _get('gender') | gender }}</div>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:[`item.action`]="{ item }">
      <div>
        <OwnClassListAction
          :teacher="(item.headTeachers && item.headTeachers.length) ? item.headTeachers[0] : {}"
          :ownClass="item"
        />
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import OwnClassListAction from '@/modules/teacher/OwnClassListAction.vue'

const originHeaders = [
  {
    text: 'Lớp',
    value: 'title',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Khối',
    value: 'grade.gradeNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Giáo viên chủ nhiệm',
    value: 'headTeachers',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
    sortable: false,
    show: true
  }
]

export default {
  components: {
    CardTeacherName,
    OwnClassListAction
  },
  data() {
    return {
      headers: originHeaders,
      ownClassTeachers: [],
      tableOptions: {}
    }
  },
  computed: {
    ...mapState('ownClassTeacher', ['ownClassTeacherData', 'classesData', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Lớp mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('ownClassTeacher', ['searchClasses', 'requestPageSettings']),
    async refresh(query) {
      await this.searchClasses({ ...query })
    }
  },
  async created() {
    await this.refresh({})
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>
